import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../../mensajes2";
import { Dimmer } from "../../spinner";
import axios from "axios";
import CatalogoOrganizacion from "../../../catalogos/catalogoOrganizacion";
import CatalogoPersona from "../../../catalogos/catalogoPersona";
import {
  validaSoloNumero,
  validaNumeroTelefono,
  validaEmail,
} from "../../../util/varios";

import moment from "moment";
import { Input, SearchInput, Select, Textarea } from "../../../ui/inputs/Input";
import { DangerButton, InfoButton, SuccessButton } from "../../../ui/buttons/Button";

export const ActualizarUsuario = (props) => {
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const [mostrar, setMostrar] = useState(false);
  const [mostrar1, setMostrar1] = useState(false);
  const [mostrar2, setMostrar2] = useState(false);
  const [mostrar3, setMostrar3] = useState(false);
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [contar, setContar] = useState(0);
  const [contar2, setContar2] = useState(0);
  const [titulo2, setTitulo2] = useState();
  const [msg2, setMsg2] = useState();
  const [dato, setDato] = useState([3]);
  const [dato2, setDato2] = useState("");
  const [password, setPassword] = useState("");
  const [activate, setActivate] = useState(false);
  const [usuario, setUsuario] = useState();
  const [persona, setPersona] = useState({
    cedula: "",
    nombres: "",
    apellidos: "",
    direccion: "",
    correoe: "",
    tlf1: "",
    tlf2: "",
    fnacimiento: "",
    nacionalidad: "",
    sexo: "",
  });
  const [mostrarClave, setMostrarClave] = useState(false);
  const [mostrarClave1, setMostrarClave1] = useState(false);
  const [correo, setCorreo] = useState("");
  const [modulos, setModulos] = useState({
    accedoctavehiculo: "0",

    accconfigvehiculo: "0",
    accrepgenvehi: "0",
    accrepcontvehideud: "0",
    accreptipvehi: "0",
    accimpedoctasectcome: "0",
  });
  const [permisos, setPermisos] = useState({
    accvehiculo: "0000",
    accclasevehiculo: "0000",
    accusuariovehiculo: "0000",
  });

  const [url, setUrl] = useState("");

  let op = require("../../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");

  const [deshabilitado, setDeshabilitado] = useState(false);
  const [habilitadoNU, setHabilitadoNU] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [operacionPer, setOperacionPer] = useState(0);
  const [tecla, setTecla] = useState();
  const [tabIndex, setTabIndex] = useState(0);
  const [tabIndex1, setTabIndex1] = useState(0);
  const [fechaSistema, setFechaSistema] = useState(
    localStorage.getItem("fechasistema")
  );
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [desde, setDesde] = useState(0);
  const txtIdUsuario = useRef();
  const txtLogin = useRef();
  const txtPassword = useRef();
  const txtConfirmPassword = useRef();
  const txtIdOrg = useRef();
  const txtNomOrg = useRef();
  const txtCedula = useRef();
  const txtNombreUsuario = useRef();
  const txtApellidoUsuario = useRef();
  const txtDireccionUsuario = useRef();
  const txtEmailUsuario = useRef();
  const txtTlfUsuario = useRef();
  const txtCelUsuario = useRef();
  const txtFechaNac = useRef();
  const cmbNacionalidad = useRef();
  const cmbSexo = useRef();

  useEffect(() => {
    let obj = JSON.parse(localStorage.getItem("post"));
    setFechaSistema(obj.fechasistema);
    if (props.operacion) {
      setOperacion(props.operacion);
    }
    if (op.reportes != null) {
      setUrl(op.reportes.trim());
    } else {
      setUrl("");
    }
  }, [props.operacion]);
  const procesarRegistro = (body) => {
    let endpoint = `${op.conexion}/api/comun/actualizarusuario/${operacion}`;
    console.log(body);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          let per = JSON.parse(localStorage.getItem("idusuario"));
          if (per === txtIdUsuario.current.value) {
            localStorage.setItem(
              "accedoctavehiculo",
              JSON.stringify(modulos.accedoctavehiculo)
            );
            localStorage.setItem(
              "accconfigvehiculo",
              JSON.stringify(modulos.accconfigvehiculo)
            );
            localStorage.setItem(
              "accrepgenvehi",
              JSON.stringify(modulos.accrepgenvehi)
            );
            localStorage.setItem(
              "accrepcontvehideud",
              JSON.stringify(modulos.accrepcontvehideud)
            );
            localStorage.setItem(
              "accreptipvehi",
              JSON.stringify(modulos.accreptipvehi)
            );
            localStorage.setItem(
              "accimpedoctasectcome",
              JSON.stringify(modulos.accimpedoctasectcome)
            );
            localStorage.setItem(
              "accvehiculo",
              JSON.stringify(permisos.accvehiculo)
            );
            localStorage.setItem(
              "accclasevehiculo",
              JSON.stringify(permisos.accclasevehiculo)
            );
            localStorage.setItem(
              "accusuariovehiculo",
              JSON.stringify(permisos.accusuariovehiculo)
            );
          }
          if (operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "El usuario " +
                response.data.iduser +
                " ha sido registrado de manera satisfactoria.",
              icono: "exito",
            });
          } else if (operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "El usuario " +
                response.data.iduser +
                " ha sido modificado de manera satisfactoria.",
              icono: "exito",
            });
          } else if (operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "El usuario " +
                response.data.iduser +
                " ha sido eliminado de manera satisfactoria.",
              icono: "exito",
            });
          }
          setActivate(false);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };
  const datosOrga = (idorganizacion) => {
    let campos = "*";
    let nomtab = "organizacion";
    let nomid = "idorganizacion";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idorganizacion}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setHabilitadoNU(true);
          if (response.data !== "") {
            txtNomOrg.current.value = response.data.nombre;
            txtCedula.current.focus();
            setContar(contar + 1);
          } else {
            txtNomOrg.current.value = "";
            txtIdOrg.current.value = "";
            setTitulo("Error");
            setMsg("La Organizacion no existe.");
            setMostrar(true);
            setContar(contar + 1);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };
  const datosRes = (cedula) => {
    let campos = "*";
    let nomtab = "persona";
    let nomid = "cedula";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${cedula}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (props.ingresa === 0) {
            txtNombreUsuario.current.value = "";
            txtApellidoUsuario.current.value = "";
            txtDireccionUsuario.current.value = "";
            txtEmailUsuario.current.value = "";
            txtTlfUsuario.current.value = "";
            txtCelUsuario.current.value = "";
            txtFechaNac.current.value = "";
            cmbNacionalidad.current.value = "V";
            cmbSexo.current.value = "M";
          }
          setHabilitadoNU(true);
          if (response.data !== "") {
            setHabilitadoNU(false);
            setOperacionPer(0);
            txtNombreUsuario.current.value = response.data.nombres;
            txtApellidoUsuario.current.value = response.data.apellidos;
            txtDireccionUsuario.current.value = response.data.direccion;
            txtEmailUsuario.current.value = response.data.correoe;
            txtTlfUsuario.current.value = response.data.tlf1;
            txtCelUsuario.current.value = response.data.tlf2;
            txtFechaNac.current.value = moment.utc(
              response.data.fnacimiento
            ).format("YYYY-MM-DD");
            cmbNacionalidad.current.value = response.data.nacionalidad;
            cmbSexo.current.value = response.data.sexo;
            if (tecla === 13) {
              setTabIndex(1);
              setTabIndex1(0);
              btnAcepta.current.focus();
            }
          } else {
            setOperacionPer(1);
            setHabilitadoNU(true);
            if (tecla === 13) {
              setTimeout(() => {
                txtNombreUsuario.current.focus();
              }, 100);
            }
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const validarOrg = (event) => {
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        setContar(0);
        datosOrga(event.target.value);
      } else {
        txtNomOrg.current.value = "";
        txtIdOrg.current.value = "";
      }
    }
  };

  const handleCloseCatalogo = () => {
    setMostrar2(false);
  };

  const handleAceptaCatalogo = (idOrg, nomOrg) => {
    setMostrar2(false);
    txtIdOrg.current.value = idOrg;
    txtNomOrg.current.value = nomOrg;
  };

  const catalogoOrg = () => {
    setMostrar2(true);
  };

  const handleCloseCatalogoPer = () => {
    setMostrar3(false);
  };

  const handleAceptaCatalogoPer = (
    cedPer,
    nomPer,
    apePer,
    correoPer,
    tlf1Per,
    tlf2Per,
    fnacPer,
    nacPer,
    sexoPer,
    direPer
  ) => {
    setMostrar3(false);
    txtCedula.current.value = cedPer;
    txtNombreUsuario.current.value = nomPer;
    txtApellidoUsuario.current.value = apePer;
    txtDireccionUsuario.current.value = direPer;
    txtEmailUsuario.current.value = correoPer;
    txtTlfUsuario.current.value = tlf1Per;
    txtCelUsuario.current.value = tlf2Per;
    txtFechaNac.current.value = fnacPer;
    cmbNacionalidad.current.value = nacPer;
    cmbSexo.current.value = sexoPer;
    btnAcepta.current.focus();
  };
  const catalogoPer = (e) => {
    e.preventDefault();
    if (operacion < 3) {
      setMostrar3(true);
    }
  };
  const blanquear = () => {
    setMostrar(false);
    setTitulo("");
    setMsg("");
    setMostrar1(false);
    setTitulo2("");
    setMsg2("");
    setDato([3]);
    setDato2("");
    setPassword("");
    setActivate(false);
    setCorreo("");
    setDesde(0);
    setModulos({
      accedoctavehiculo: "0",
      accconfigvehiculo: "0",
      accrepgenvehi: "0",
      accrepcontvehideud: "0",
      accreptipvehi: "0",
      accimpedoctasectcome: "0",
    });
    setPermisos({
      accvalortipocat: "0000",
      accvehiculo: "0000",
      supercat: false,
      accavaluo: "0000",
      accdepreciacioncat: "0000",
      accvalorterrecat: "0000",
      accrepvalconstruc: "0000",
      accusuariocat: "0000",
      accclasevehiculo: "0000",
      accusuariovehiculo: "0000",
    });
  };
  const cancelar = () => {
    blanquear();
    props.onHideCancela();
  };

  const handleChangeOtro = (event) => {
    setModulos({
      ...modulos,
      [event.target.name]: event.target.value === "true" ? "1" : "0",
    });
  };

  const handleChangeChek = (event) => {
    var num;
    num = event.target.checked === true ? "1" : "0";
    if (event.target.name === "accvehiculo") {
      if (event.target.id === "chkRegContriConsul") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            num +
            permisos.accvehiculo.toString().substring(1, 2) +
            permisos.accvehiculo.toString().substring(2, 3) +
            permisos.accvehiculo.toString().substring(3, 4),
        });
      } else if (event.target.id === "chkRegContriInc") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            permisos.accvehiculo.toString().substring(0, 1) +
            num +
            permisos.accvehiculo.toString().substring(2, 3) +
            permisos.accvehiculo.toString().substring(3, 4),
        });
      } else if (event.target.id === "chkRegContriEdit") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            permisos.accvehiculo.toString().substring(0, 1) +
            permisos.accvehiculo.toString().substring(1, 2) +
            num +
            permisos.accvehiculo.toString().substring(3, 4),
        });
      } else if (event.target.id === "chkRegContriElim") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            permisos.accvehiculo.toString().substring(0, 1) +
            permisos.accvehiculo.toString().substring(1, 2) +
            permisos.accvehiculo.toString().substring(2, 3) +
            num,
        });
      } else if (event.target.id === "chkRegContriTodo") {
        setPermisos({
          ...permisos,
          [event.target.name]: event.target.checked ? "1111" : "0000",
        });
      }
    } else if (event.target.name === "accclasevehiculo") {
      if (event.target.id === "chkActiviEconoConsul") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            num +
            permisos.accclasevehiculo.toString().substring(1, 2) +
            permisos.accclasevehiculo.toString().substring(2, 3) +
            permisos.accclasevehiculo.toString().substring(3, 4),
        });
      } else if (event.target.id === "chkActiviEconoInc") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            permisos.accclasevehiculo.toString().substring(0, 1) +
            num +
            permisos.accclasevehiculo.toString().substring(2, 3) +
            permisos.accclasevehiculo.toString().substring(3, 4),
        });
      } else if (event.target.id === "chkActiviEconoEdit") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            permisos.accclasevehiculo.toString().substring(0, 1) +
            permisos.accclasevehiculo.toString().substring(1, 2) +
            num +
            permisos.accclasevehiculo.toString().substring(3, 4),
        });
      } else if (event.target.id === "chkActiviEconoElim") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            permisos.accclasevehiculo.toString().substring(0, 1) +
            permisos.accclasevehiculo.toString().substring(1, 2) +
            permisos.accclasevehiculo.toString().substring(2, 3) +
            num,
        });
      } else if (event.target.id === "chkActiviEconoTodo") {
        setPermisos({
          ...permisos,
          [event.target.name]: event.target.checked ? "1111" : "0000",
        });
      }
    } else if (event.target.name === "accusuariovehiculo") {
      if (event.target.id === "chkUsuarioComeConsul") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            num +
            permisos.accusuariovehiculo.toString().substring(1, 2) +
            permisos.accusuariovehiculo.toString().substring(2, 3) +
            permisos.accusuariovehiculo.toString().substring(3, 4),
        });
      } else if (event.target.id === "chkUsuarioComeInc") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            permisos.accusuariovehiculo.toString().substring(0, 1) +
            num +
            permisos.accusuariovehiculo.toString().substring(2, 3) +
            permisos.accusuariovehiculo.toString().substring(3, 4),
        });
      } else if (event.target.id === "chkUsuarioComeEdit") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            permisos.accusuariovehiculo.toString().substring(0, 1) +
            permisos.accusuariovehiculo.toString().substring(1, 2) +
            num +
            permisos.accusuariovehiculo.toString().substring(3, 4),
        });
      } else if (event.target.id === "chkUsuarioComeElim") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            permisos.accusuariovehiculo.toString().substring(0, 1) +
            permisos.accusuariovehiculo.toString().substring(1, 2) +
            permisos.accusuariovehiculo.toString().substring(2, 3) +
            num,
        });
      } else if (event.target.id === "chkUsuarioComeTodo") {
        setPermisos({
          ...permisos,
          [event.target.name]: event.target.checked ? "1111" : "0000",
        });
      }
    }
  };

  const handleInputChange = (event) => {
    if (event.which === 13) {
      var valido;
      if (event.target.id === "inputCodigo") {
        txtLogin.current.focus();
      } else if (event.target.id === "inputLogin") {
        txtPassword.current.focus();
      } else if (event.target.id === "inputPassword") {
        if (
          txtConfirmPassword.current.value !== "" &&
          txtPassword.current.value !== txtConfirmPassword.current.value
        ) {
          setTitulo("Información");
          setMsg("Las Contraseñas no coinciden.");
          setMostrar(true);
          txtPassword.current.focus();
        } else {
          txtConfirmPassword.current.focus();
        }
      } else if (event.target.id === "inputConfirmPassword") {
        if (
          txtConfirmPassword.current.value !== "" &&
          txtPassword.current.value !== txtConfirmPassword.current.value
        ) {
          setTitulo("Información");
          setMsg("Las Contraseñas no coinciden.");
          setMostrar(true);
          txtConfirmPassword.current.focus();
        } else {
          txtIdOrg.current.focus();
        }
      } else if (event.target.id === "inputNomUsuario") {
        txtApellidoUsuario.current.focus();
      } else if (event.target.id === "inputApeUsuario") {
        txtDireccionUsuario.current.focus();
      } else if (event.target.id === "inputDireUsuario") {
        txtEmailUsuario.current.focus();
      } else if (event.target.id === "inputEmailUsuario") {
        valido = validaEmail(event.target.value);
        if (valido) {
          txtTlfUsuario.current.focus();
        } else {
          if (event.target.value !== "") {
            setTitulo("Información");
            setMsg("Formato de Email invalido.");
            setMostrar(true);
            event.target.value = "";
          } else {
            txtTlfUsuario.current.focus();
          }
        }
      } else if (event.target.id === "inputTlfUsuario") {
        valido = validaNumeroTelefono(event.target.value);
        if (valido) {
          txtCelUsuario.current.focus();
        } else {
          if (event.target.value !== "") {
            setTitulo("Información");
            setMsg("Formato de número telefonico invalido.");
            setMostrar(true);
            event.target.value = "";
          } else {
            txtCelUsuario.current.focus();
          }
        }
      } else if (event.target.id === "inputCelUsuario") {
        valido = validaNumeroTelefono(event.target.value);
        if (valido) {
          txtFechaNac.current.focus();
        } else {
          if (event.target.value !== "") {
            setTitulo("Información");
            setMsg("Formato de número telefonico invalido.");
            setMostrar(true);
            event.target.value = "";
          } else {
            txtFechaNac.current.focus();
          }
        }
      } else if (event.target.id === "inputFechaNac") {
        cmbNacionalidad.current.focus();
      }
    } else if (typeof event.which === "undefined") {
      if (event.target.id === "inputPassword") {
        if (
          txtConfirmPassword.current.value !== "" &&
          txtPassword.current.value !== txtConfirmPassword.current.value
        ) {
          setTitulo("Información");
          setMsg("Las Contraseñas no coinciden.");
          setMostrar(true);
        }
      } else if (event.target.id === "inputConfirmPassword") {
        if (
          txtConfirmPassword.current.value !== "" &&
          txtPassword.current.value !== txtConfirmPassword.current.value
        ) {
          setTitulo("Información");
          setMsg("Las Contraseñas no coinciden.");
          setMostrar(true);
        }
      } else if (event.target.id === "inputEmailUsuario") {
        valido = validaEmail(event.target.value);
        if (valido) {
          txtTlfUsuario.current.focus();
        } else {
          if (event.target.value !== "") {
            setTitulo("Información");
            setMsg("Formato de Email invalido.");
            //setMostrar(true);
            event.target.value = "";
          } else {
            txtTlfUsuario.current.focus();
          }
        }
      } else if (event.target.id === "inputTlfUsuario") {
        valido = validaNumeroTelefono(event.target.value);
        if (valido) {
          txtCelUsuario.current.focus();
        } else {
          if (event.target.value !== "") {
            setTitulo("Información");
            setMsg("Formato de número telefonico invalido.");
            //setMostrar(true);
            event.target.value = "";
          } else {
            txtCelUsuario.current.focus();
          }
        }
      } else if (event.target.id === "inputCelUsuario") {
        valido = validaNumeroTelefono(event.target.value);
        if (valido) {
          txtFechaNac.current.focus();
        } else {
          if (event.target.value !== "") {
            setTitulo("Información");
            setMsg("Formato de número telefonico invalido.");
            event.target.value = "";
          } else {
            txtFechaNac.current.focus();
          }
        }
      } else {
        return false;
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };
  const validarPersona = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        setContar(0);
        setTecla(event.which);
        datosRes(event.target.value);
      } else {
        txtNombreUsuario.current.value = "";
      }
    }
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;
    if (txtLogin.current.value.trim() === "") {
      setTitulo("Error");
      setMsg("El Usuario no debe estar vacio");
      sigue = false;
      setTabIndex(0);
      txtLogin.current.focus();
    } else if (txtPassword.current.value.trim() === "" && operacion === 1) {
      setTitulo("Error");
      setMsg("La Contraseña no debe estar vacia");
      sigue = false;
      setTabIndex(0);
      txtPassword.current.focus();
    } else if (
      txtConfirmPassword.current.value.trim() === "" &&
      operacion === 1
    ) {
      setTitulo("Error");
      setMsg("La Confirmación de la Contraseña no debe estar vacia");
      sigue = false;
      setTabIndex(0);
      txtConfirmPassword.current.focus();
    } else if (
      txtPassword.current.value.trim() !==
        txtConfirmPassword.current.value.trim() &&
      operacion === 1
    ) {
      setTitulo("Error");
      setMsg("Las Contraseñas no coinciden");
      sigue = false;
      setTabIndex(0);
      txtConfirmPassword.current.focus();
    } else if (txtIdOrg.current.value.trim() === "") {
      setTitulo("Error");
      setMsg("El Código de la rganización no debe estar vacio");
      sigue = false;
      setTabIndex(0);
      txtIdOrg.current.focus();
    } else if (txtNomOrg.current.value.trim() === "") {
      setTitulo("Error");
      setMsg("El Nombre de la rganización no debe estar vacio");
      sigue = false;
      setTabIndex(0);
      txtNomOrg.current.focus();
    } else if (txtCedula.current.value.trim() === "") {
      setTitulo("Error");
      setMsg("La cedula no debe estar vacia");
      sigue = false;
      txtCedula.current.focus();
    } else if (txtNombreUsuario.current.value.trim() === "") {
      setTitulo("Error");
      setMsg("Los nombres no deben estar vacios");
      sigue = false;
      txtNombreUsuario.current.focus();
    } else if (txtApellidoUsuario.current.value.trim() === "") {
      setTitulo("Error");
      setMsg("Los Apellidos no deben estar vacio");
      sigue = false;
      txtApellidoUsuario.current.focus();
    } else if (txtDireccionUsuario.current.value.trim() === "") {
      setTitulo("Error");
      setMsg("La direccion del Usuario no debe estar vacia");
      sigue = false;
      txtDireccionUsuario.current.focus();
    } else if (txtFechaNac.current.value.trim() === "") {
      setTitulo("Error");
      setMsg("La fecha de nacimiento no debe estar vacia");
      sigue = false;
      txtFechaNac.current.focus();
    }

    if (sigue) {
      var user = [];
      var datoPer = [];
      user.push({
        idusuario:
          txtIdUsuario.current.value === "" ? "0" : txtIdUsuario.current.value,
        login: txtLogin.current.value,
        passwd: txtPassword.current.value,
        idorganizacion: txtIdOrg.current.value,

        persona: txtCedula.current.value,

        accedoctavehiculo: modulos.accedoctavehiculo,

        accconfigvehiculo: modulos.accconfigvehiculo,
        accrepgenvehi: modulos.accrepgenvehi,
        accrepcontvehideud: modulos.accrepcontvehideud,
        accreptipvehi: modulos.accreptipvehi,
        accvehiculo: permisos.accvehiculo,
        accclasevehiculo: permisos.accclasevehiculo,

        accusuariovehiculo: permisos.accusuariovehiculo,
      });
      datoPer.push({
        apellidos: txtApellidoUsuario.current.value.trim().toupperCase(),
        cedula: txtCedula.current.value,
        correoe: txtEmailUsuario.current.value,
        direccion: txtDireccionUsuario.current.value.trim().toUpperCase(),
        fnacimiento: txtFechaNac.current.value,
        nacionalidad: cmbNacionalidad.current.value,
        nombres: txtNombreUsuario.current.value.trim().toUpperCase(),
        sexo: cmbSexo.current.value,
        tlf1: txtTlfUsuario.current.value,
        tlf2: txtCelUsuario.current.value,
      });
      setUsuario(user);
      setPersona(datoPer);
      setActivate(true);
      setContar2(0);
      let body = {
        operacionper: operacionPer,
        usu: JSON.stringify(user),
        perso: JSON.stringify(datoPer),
      };
      procesarRegistro(body);
    } else {
      setMostrar(true);
    }
  };

  const mostrarPassword = () => setMostrarClave(!mostrarClave);
  const mostrarPassword1 = () => setMostrarClave1(!mostrarClave1);

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.render();
    blanquear();
  };
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        setDeshabilitado(props.deshabilitado);
        setTabIndex(0);
        setTabIndex1(0);
        console.log(props.operacion);

        if (props.usuario) {
          setModulos({
            accedoctavehiculo:
              props.usuario.accedoctavehiculo === null
                ? "0"
                : props.usuario.accedoctavehiculo,
            accconfigvehiculo:
              props.usuario.accconfigvehiculo === null
                ? "0"
                : props.usuario.accconfigvehiculo,
            accrepgenvehi:
              props.usuario.accrepgenvehi === null
                ? "0"
                : props.usuario.accrepgenvehi,
            accrepcontvehideud:
              props.usuario.accrepcontvehideud === null
                ? "0"
                : props.usuario.accrepcontvehideud,
            accreptipvehi:
              props.usuario.accreptipvehi === null
                ? "0"
                : props.usuario.accreptipvehi,
          });
          setPermisos({
            accvehiculo:
              props.usuario.accvehiculo === null
                ? "0000"
                : props.usuario.accvehiculo,
            accclasevehiculo:
              props.usuario.accclasevehiculo === null
                ? "0000"
                : props.usuario.accclasevehiculo,

            accusuariovehiculo:
              props.usuario.accusuariovehiculo === null
                ? "0000"
                : props.usuario.accusuariovehiculo,
          });
        } else {
          setModulos({
            accedoctavehiculo: "0",

            accconfigvehiculo: "0",
            accrepgenvehi: "0",
            accrepcontvehideud: "0",
            accreptipvehi: "0",
          });
          setPermisos({
            accvehiculo: "0000",
            accclasevehiculo: "0000",

            accusuariovehiculo: "0000",
          });
        }
      }}
    >
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light">
        <h3 className="fw-bold m-0">
          {operacion === 1
            ? "Agregar Usuario."
            : operacion === 2
            ? "Editar Usuario."
            : operacion === 3
            ? "Eliminar Usuario."
            : "Consultar Usuario."}
        </h3>
        <a type="button" className="fw-bold text-light fs-6" onClick={cancelar}>
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body >
        <div>
          <ul className="nav" id="myTab" role="tablist">
            <li className="nav-item" role="presentation">
              <a
                className=" rounded nav-link active bg-blue-100 text-light"
                id="datosTributarios2"
                data-bs-toggle="tab"
                data-bs-target="#tributarios2"
                type="button"
                role="tab"
                aria-controls="tributarios2"
                aria-selected="true"
              >
                Usuario
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className=" rounded nav-link bg-blue-200 text-light"
                id="deuda-tab2"
                data-bs-toggle="tab"
                data-bs-target="#deuda2"
                type="button"
                role="tab"
                aria-controls="deuda2"
                aria-selected="false"
              >
                Permisos de Aplicaciones
              </a>
            </li>
          </ul>
          <div className="tab-content m-0 p-0" id="myTabContent">
            <div
              className="tab-pane fade show active m-0 p-0"
              id="tributarios2"
              role="tabpanel"
              aria-labelledby="datosTributarios2"
            >
            <div className="col-12 m-0 mt-2 p-0 d-flex flex-wrap">
                <div class="col-3 m-0 mb-2 p-0">
                    <Input label = 'Código:'
                    disabled={true}
                    ref={txtIdUsuario}
                    defaultValue={props.usuario ? props.usuario.idusuario : ""}
                    id="inputCodigo"
                    onKeyUp={handleInputChange}
                    />
                </div>
                <div class="col-6 m-0 mb-2 ml-auto p-0 pl-2">
                    <Input label = 'Usuario:'
                    autocomplete="off"
                    disabled={
                        operacion === 4 || operacion === 2 ? true : deshabilitado
                    }
                    ref={txtLogin}
                    defaultValue={props.usuario ? props.usuario.login : ""}
                    id="inputLogin"
                    onKeyUp={handleInputChange}
                    />
                </div>
                <div class="col-6 m-0 p-0 d-flex input-group-sm">
                    <Input label = 'Ingrese Contraseña:'
                    type={mostrarClave ? "text" : "password"}
                    disabled={
                        operacion === 4 || operacion === 2 ? true : deshabilitado
                    }
                    ref={txtPassword}
                    className="form-control form-control-sm"
                    id="inputPassword"
                    onKeyUp={handleInputChange}
                    />
                    <InfoButton icon = 'fa-eye-slash m-0'
                    className = 'rounded-0'
                    disabled={
                        operacion === 4 || operacion === 2 ? true : deshabilitado
                    }
                    onClick={mostrarPassword}
                    />
                </div>
                <div class="col-6 m-0 p-0 pl-2 d-flex input-group-sm">
                    <Input label = 'Confirmar Contraseña:'
                    type={mostrarClave1 ? "text" : "password"}
                    disabled={
                        operacion === 4 || operacion === 2 ? true : deshabilitado
                    }
                    ref={txtConfirmPassword}
                    id="inputConfirmPassword"
                    onKeyUp={handleInputChange}
                    />
                    <InfoButton icon = 'fa-eye-slash m-0'
                    className = 'rounded-0'
                    disabled={
                        operacion === 4 || operacion === 2 ? true : deshabilitado
                    }
                    onClick={mostrarPassword1}
                    />
                </div>
                <fieldset className="col-12 m-0 p-2 d-flex border-azul rounded">
                <legend className="float-none w-auto m-0">Organización</legend>
                <div class="col-12 m-0 p-0 d-flex">
                    <div className="col-4 m-0 p-0">
                    <SearchInput label = 'Código:'
                        disabled={operacion === 1 || operacion === 2 ? false : true}
                        ref={txtIdOrg}
                        id="inputIdOrg"
                        defaultValue={
                        props.usuario ? props.usuario.idorganizacion : ""
                        }
                        onKeyUp={validarOrg}
                        onBlur={validarOrg}
                        onClickButton = {catalogoOrg}
                        disabledButton = {operacion === 1 || operacion === 2 ? false : true}
                    />
                    </div>
                    <Input 
                    disabled={true}
                    ref={txtNomOrg}
                    defaultValue={
                        props.usuario ? props.usuario.razonsocial : ""
                    }
                    onKeyUp={handleInputChange}
                    onBlur={handleInputChange}
                    />
                </div>
                </fieldset>
                <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
                <legend className="float-none w-auto ">Datos Personales</legend>
                <div class="col-5 m-0 mb-2 p-0 d-flex">
                    <Select label = 'Cédula:'
                        disabled={!habilitadoNU}
                        ref={cmbNacionalidad}
                        defaultValue={
                            props.datospersonales
                            ? props.datospersonales.nacionalidad
                            : ""
                        }
                        >
                        <option key="0" value="V">
                            V
                        </option>
                        <option key="1" value="E">
                            E
                        </option>
                    </Select>
                    <SearchInput
                        disabled={operacion === 1 || operacion === 2 ? false : true}
                        ref={txtCedula}
                        id="inputCedula"
                        defaultValue={
                            props.datospersonales ? props.datospersonales.cedula : ""
                        }
                        onKeyUp={validarPersona}
                        onBlur={validarPersona}
                        disabledButton = {operacion === 1 || operacion === 2 ? false : true}
                        onClickButton = {catalogoPer}
                    />
                </div>
                <div class="col-5 m-0 mb-2 ml-auto p-0 pl-2">
                    <Input label = 'Fecha de Nacimiento:'
                    type="date"
                    disabled={!habilitadoNU}
                    ref={txtFechaNac}
                    id="inputFechaNac"
                    max={fechaSistema}
                    defaultValue={
                        props.datospersonales
                        ? moment.utc(props.datospersonales.fnacimiento).format(
                            "YYYY-MM-DD"
                            )
                        : ""
                    }
                    onKeyUp={handleInputChange}
                    />
                </div>
                <div class="col-6 m-0 mb-2 p-0">
                    <Input label = 'Nombres:'
                    disabled={!habilitadoNU}
                    ref={txtNombreUsuario}
                    id="inputNomUsuario"
                    defaultValue={
                        props.datospersonales
                        ? props.datospersonales.nombres.trim()
                        : ""
                    }
                    onKeyUp={handleInputChange}
                    onBlur={handleInputChange}
                    />
                </div>
                <div class="col-6 m-0 mb-2 p-0 pl-2">
                    <Input label = 'Apellidos:'
                    disabled={!habilitadoNU}
                    ref={txtApellidoUsuario}
                    id="inputApeUsuario"
                    defaultValue={
                        props.datospersonales
                        ? props.datospersonales.apellidos.trim()
                        : ""
                    }
                    onKeyUp={handleInputChange}
                    onBlur={handleInputChange}
                    />
                </div>
                <div class="col-12 m-0 mb-2 p-0">
                    <Textarea label = 'Dirección:'
                    style={{ height: 70 }}
                    disabled={!habilitadoNU}
                    ref={txtDireccionUsuario}
                    id="inputDireUsuario"
                    defaultValue={
                        props.datospersonales
                        ? props.datospersonales.direccion.trim()
                        : ""
                    }
                    onKeyUp={handleInputChange}
                    onBlur={handleInputChange}
                    />
                </div>
                <div class="col-4 m-0 mb-2 p-0">
                    <Input label = 'Correo:'
                    disabled={!habilitadoNU}
                    ref={txtEmailUsuario}
                    id="inputEmailUsuario"
                    defaultValue={
                        props.datospersonales
                        ? props.datospersonales.correoe !== null
                            ? props.datospersonales.correoe.trim()
                            : ""
                        : ""
                    }
                    onKeyUp={handleInputChange}
                    onBlur={handleInputChange}
                    />
                </div>
                <div class="col-4 m-0 mb-2 p-0 pl-2">
                    <Input label = 'Telefono:'
                    disabled={!habilitadoNU}
                    ref={txtTlfUsuario}
                    id="inputTlfUsuario"
                    placeholder="0000-0000000"
                    defaultValue={
                        props.datospersonales
                        ? props.datospersonales.tlf1 !== null
                            ? props.datospersonales.tlf1.trim()
                            : ""
                        : ""
                    }
                    onKeyUp={handleInputChange}
                    onBlur={handleInputChange}
                    />
                </div>
                <div class="col-4 m-0 mb-2 p-0 pl-2">
                    <Input label = 'Celular:'
                    disabled={!habilitadoNU}
                    ref={txtCelUsuario}
                    id="inputCelUsuario"
                    placeholder="0000-0000000"
                    defaultValue={
                        props.datospersonales
                        ? props.datospersonales.tlf2 !== null
                            ? props.datospersonales.tlf2.trim()
                            : ""
                        : ""
                    }
                    onKeyUp={handleInputChange}
                    onBlur={handleInputChange}
                    />
                </div>
                <div class="col-3 m-0 p-0">
                    <Select label = 'Sexo:'
                    disabled={!habilitadoNU}
                    ref={cmbSexo}
                    defaultValue={
                        props.datospersonales ? props.datospersonales.sexo : ""
                    }
                    >
                    <option key="0" value="M">
                        M
                    </option>
                    <option key="1" value="F">
                        F
                    </option>
                    </Select>
                </div>
                </fieldset>
            </div>
            </div>

            <div
              className="tab-pane fade"
              id="deuda2"
              role="tabpanel"
              aria-labelledby="deuda-tab2"
            >
              <ul className="nav" id="myTab" role="tablist">
                <li className="nav-item" role="presentation">
                  <a
                    className=" rounded nav-link active bg-blue-100 text-light"
                    id="datosTributarios"
                    data-bs-toggle="tab"
                    data-bs-target="#tributarios"
                    type="button"
                    role="tab"
                    aria-controls="tributarios"
                    aria-selected="true"
                  >
                    Actualización
                  </a>
                </li>
                <li className="nav-item" role="presentation">
                  <a
                    className=" rounded nav-link bg-blue-200 text-light"
                    disabled={
                      operacion === 1 || operacion === 3 ? true : deshabilitado
                    }
                    id="deuda-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#deuda"
                    type="button"
                    role="tab"
                    aria-controls="deuda"
                    aria-selected="false"
                  >
                    Reportes
                  </a>
                </li>
                <li className="nav-item" role="presentation">
                  <a
                    className=" rounded nav-link bg-blue-300 text-light"
                    disabled={
                      operacion === 1 || operacion === 3 ? true : deshabilitado
                    }
                    id="hist-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#historico"
                    type="button"
                    role="tab"
                    aria-controls="historico"
                    aria-selected="false"
                  >
                    Usuarios
                  </a>
                </li>
              </ul>
              <div className="tab-content" id="myTabContent">
                <div
                  className="tab-pane fade show active border-azul rounded"
                  id="tributarios"
                  role="tabpanel"
                  aria-labelledby="datosTributarios"
                >
                  <div className="col-md-12 row mx-auto">
                    <div className="col-md-12 row mx-auto rounded border my-2 py-2">
                      <div className="col-md-5">Registro de Vehiculos</div>
                      <div className="col px-0">
                        <input
                          type="checkbox"
                          style={{ marginRight: "3px" }}
                          id="chkRegContriConsul"
                          name="accvehiculo"
                          disabled={deshabilitado}
                          checked={
                            permisos.accvehiculo.toString().substring(0, 1) ===
                            "1"
                          }
                          onChange={handleChangeChek}
                        />
                        Consultar
                        <a> &nbsp; </a>
                        <input
                          type="checkbox"
                          style={{ marginRight: "3px" }}
                          id="chkRegContriInc"
                          name="accvehiculo"
                          disabled={deshabilitado}
                          checked={
                            permisos.accvehiculo.toString().substring(1, 2) ===
                            "1"
                          }
                          onChange={handleChangeChek}
                        />
                        Incluir
                        <a> &nbsp; </a>
                        <input
                          type="checkbox"
                          style={{ marginRight: "3px" }}
                          id="chkRegContriEdit"
                          name="accvehiculo"
                          disabled={deshabilitado}
                          checked={
                            permisos.accvehiculo.toString().substring(2, 3) ===
                            "1"
                          }
                          onChange={handleChangeChek}
                        />
                        Editar
                        <a> &nbsp; </a>
                        <input
                          type="checkbox"
                          style={{ marginRight: "3px" }}
                          id="chkRegContriElim"
                          name="accvehiculo"
                          disabled={deshabilitado}
                          checked={
                            permisos.accvehiculo.toString().substring(3, 4) ===
                            "1"
                          }
                          onChange={handleChangeChek}
                        />
                        Eliminar
                        <a> &nbsp; </a>
                        <input
                          type="checkbox"
                          style={{ marginRight: "3px" }}
                          id="chkRegContriTodo"
                          name="accvehiculo"
                          disabled={deshabilitado}
                          checked={permisos.accvehiculo.toString() === "1111"}
                          onChange={handleChangeChek}
                        />
                        Todas
                      </div>
                    </div>

                    <div className="col-md-12 row mx-auto rounded border my-2 py-2">
                      <div className="col-md-5">
                        Clasificador de Código de Vehiculos
                      </div>
                      <div className="col px-0">
                        <input
                          type="checkbox"
                          style={{ marginRight: "3px" }}
                          id="chkActiviEconoConsul"
                          name="accclasevehiculo"
                          disabled={deshabilitado}
                          checked={
                            permisos.accclasevehiculo
                              .toString()
                              .substring(0, 1) === "1"
                          }
                          onChange={handleChangeChek}
                        />
                        Consultar
                        <a> &nbsp; </a>
                        <input
                          type="checkbox"
                          style={{ marginRight: "3px" }}
                          id="chkActiviEconoInc"
                          name="accclasevehiculo"
                          disabled={deshabilitado}
                          checked={
                            permisos.accclasevehiculo
                              .toString()
                              .substring(1, 2) === "1"
                          }
                          onChange={handleChangeChek}
                        />
                        Incluir
                        <a> &nbsp; </a>
                        <input
                          type="checkbox"
                          style={{ marginRight: "3px" }}
                          id="chkActiviEconoEdit"
                          name="accclasevehiculo"
                          disabled={deshabilitado}
                          checked={
                            permisos.accclasevehiculo
                              .toString()
                              .substring(2, 3) === "1"
                          }
                          onChange={handleChangeChek}
                        />
                        Editar
                        <a> &nbsp; </a>
                        <input
                          type="checkbox"
                          style={{ marginRight: "3px" }}
                          id="chkActiviEconoElim"
                          name="accclasevehiculo"
                          disabled={deshabilitado}
                          checked={
                            permisos.accclasevehiculo
                              .toString()
                              .substring(3, 4) === "1"
                          }
                          onChange={handleChangeChek}
                        />
                        Eliminar
                        <a> &nbsp; </a>
                        <input
                          type="checkbox"
                          style={{ marginRight: "3px" }}
                          id="chkActiviEconoTodo"
                          name="accclasevehiculo"
                          disabled={deshabilitado}
                          checked={
                            permisos.accclasevehiculo.toString() === "1111"
                          }
                          onChange={handleChangeChek}
                        />
                        Todas
                      </div>
                    </div>
                    <div className="col-md-12 row mx-auto rounded border my-2 py-2">
                      <div className="col-md-6">Estados de Cuenta</div>
                      <div className="col row">
                        <div className="form-check form-check-inline col">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="accedoctavehiculo"
                            disabled={deshabilitado}
                            id="inlineRadio1"
                            value={true}
                            checked={modulos.accedoctavehiculo === "1"}
                            onChange={handleChangeOtro}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineRadio1"
                          >
                            Disponible
                          </label>
                        </div>
                        <div className="form-check form-check-inline col">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="accedoctavehiculo"
                            disabled={deshabilitado}
                            id="inlineRadio2"
                            value={false}
                            checked={modulos.accedoctavehiculo === "0"}
                            onChange={handleChangeOtro}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineRadio2"
                          >
                            No disponible
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="tab-pane fade"
                  id="deuda"
                  role="tabpanel"
                  aria-labelledby="deuda-tab"
                >
                  <div className="col-md-12 row mx-auto border-azul rounded">
                    <div className="col-md-12 row mx-auto rounded border my-2 py-2">
                      <div className="col-md-6">
                        Listado General de Vehiculos
                      </div>
                      <div className="col row">
                        <div className="form-check form-check-inline col">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="accrepgenvehi"
                            disabled={deshabilitado}
                            id="inlineRadio1"
                            value={true}
                            checked={modulos.accrepgenvehi === "1"}
                            onChange={handleChangeOtro}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineRadio1"
                          >
                            Disponible
                          </label>
                        </div>
                        <div className="form-check form-check-inline col">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="accrepgenvehi"
                            disabled={deshabilitado}
                            id="inlineRadio2"
                            value={false}
                            checked={modulos.accrepgenvehi === "0"}
                            onChange={handleChangeOtro}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineRadio2"
                          >
                            No Disponible
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12 row mx-auto rounded border my-2 py-2">
                      <div className="col-md-6">
                        Listado de Contribuyentes con Deuda
                      </div>
                      <div className="col row">
                        <div className="form-check form-check-inline col">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="accrepcontvehideud"
                            disabled={deshabilitado}
                            id="inlineRadio1"
                            value={true}
                            checked={modulos.accrepcontvehideud === "1"}
                            onChange={handleChangeOtro}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineRadio1"
                          >
                            Disponible
                          </label>
                        </div>
                        <div className="form-check form-check-inline col">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="accrepcontvehideud"
                            disabled={deshabilitado}
                            id="inlineRadio2"
                            value={false}
                            checked={modulos.accrepcontvehideud === "0"}
                            onChange={handleChangeOtro}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineRadio2"
                          >
                            No disponible
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12 row mx-auto rounded border my-2 py-2">
                      <div className="col-md-6">
                        Listado Tipo de Vehiculos Según Ordenanza
                      </div>
                      <div className="col row">
                        <div className="form-check form-check-inline col">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="accreptipvehi"
                            disabled={deshabilitado}
                            id="inlineRadio1"
                            value={true}
                            checked={modulos.accreptipvehi === "1"}
                            onChange={handleChangeOtro}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineRadio1"
                          >
                            Disponible
                          </label>
                        </div>
                        <div className="form-check form-check-inline col">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="accreptipvehi"
                            disabled={deshabilitado}
                            id="inlineRadio2"
                            value={false}
                            checked={modulos.accreptipvehi === "0"}
                            onChange={handleChangeOtro}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineRadio2"
                          >
                            No Disponible
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="tab-pane fade"
                  id="historico"
                  role="tabpanel"
                  aria-labelledby="hist-tab"
                >
                  <div className="col-md-12 row mx-auto">
                    <div className="col-md-12 row mx-auto rounded border my-2 py-2">
                      <div className="col-md-5">Módulo de Usuarios</div>
                      <div className="col px-0">
                        <input
                          type="checkbox"
                          style={{ marginRight: "3px" }}
                          id="chkUsuarioComeConsul"
                          name="accusuariovehiculo"
                          disabled={deshabilitado}
                          checked={
                            permisos.accusuariovehiculo
                              .toString()
                              .substring(0, 1) === "1"
                          }
                          onChange={handleChangeChek}
                        />
                        Consultar
                        <a> &nbsp; </a>
                        <input
                          type="checkbox"
                          style={{ marginRight: "3px" }}
                          id="chkUsuarioComeInc"
                          name="accusuariovehiculo"
                          disabled={deshabilitado}
                          checked={
                            permisos.accusuariovehiculo
                              .toString()
                              .substring(1, 2) === "1"
                          }
                          onChange={handleChangeChek}
                        />
                        Incluir
                        <a> &nbsp; </a>
                        <input
                          type="checkbox"
                          style={{ marginRight: "3px" }}
                          id="chkUsuarioComeEdit"
                          name="accusuariovehiculo"
                          disabled={deshabilitado}
                          checked={
                            permisos.accusuariovehiculo
                              .toString()
                              .substring(2, 3) === "1"
                          }
                          onChange={handleChangeChek}
                        />
                        Editar
                        <a> &nbsp; </a>
                        <input
                          type="checkbox"
                          style={{ marginRight: "3px" }}
                          id="chkUsuarioComeElim"
                          name="accusuariovehiculo"
                          disabled={deshabilitado}
                          checked={
                            permisos.accusuariovehiculo
                              .toString()
                              .substring(3, 4) === "1"
                          }
                          onChange={handleChangeChek}
                        />
                        Eliminar
                        <a> &nbsp; </a>
                        <input
                          type="checkbox"
                          style={{ marginRight: "3px" }}
                          id="chkUsuarioComeTodo"
                          name="accusuariovehiculo"
                          disabled={deshabilitado}
                          checked={
                            permisos.accusuariovehiculo.toString() === "1111"
                          }
                          onChange={handleChangeChek}
                        />
                        Todas
                      </div>
                    </div>
                    <div className="col-md-12 row mx-auto rounded border my-2 py-2">
                      <div className="col-md-6">Configuración del Modulo</div>
                      <div className="col row">
                        <div className="form-check form-check-inline col">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="accconfigvehiculo"
                            disabled={deshabilitado}
                            id="inlineRadio1"
                            value={true}
                            checked={modulos.accconfigvehiculo === "1"}
                            onChange={handleChangeOtro}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineRadio1"
                          >
                            Disponible
                          </label>
                        </div>
                        <div className="form-check form-check-inline col">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="accconfigvehiculo"
                            disabled={deshabilitado}
                            id="inlineRadio2"
                            value={false}
                            checked={modulos.accconfigvehiculo === "0"}
                            onChange={handleChangeOtro}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineRadio2"
                          >
                            No Disponible
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton
          ref={btnAcepta}
          onClick={onChangeValidar}
        >
            Aceptar
        </SuccessButton>
        <DangerButton
          ref={btnCancela}
          onClick={cancelar}
        >
            Cancelar
        </DangerButton>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({
                mostrar: false,
                titulo: "",
                texto: "",
                icono: "",
              });
        }}
      />
      <CatalogoOrganizacion
        titulo={titulo}
        mensaje={msg}
        show={mostrar2}
        onHideCancelaCatOrg={handleCloseCatalogo}
        onHideAceptaCatOrg={handleAceptaCatalogo}
      />
      <CatalogoPersona
        titulo={titulo}
        mensaje={msg}
        show={mostrar3}
        onHideCancelaCatPer={handleCloseCatalogoPer}
        onHideAceptaCatPer={handleAceptaCatalogoPer}
      />
      <Dimmer active={activate} inverted></Dimmer>
    </Modal>
  );
};
